import Page from "components/Page";
import { lazyWithRetry } from "helpers/lazyWithRetry";
import { InvoicesListProps } from "./InvoicesList.types";

const Invoices = lazyWithRetry(() => import("./InvoicesList"));

export default (props: InvoicesListProps) => (
  <Page>
    <Invoices {...props} />
  </Page>
);
